<template>
    <section>
        <MainLayout>
			<div class="container">
				<div class="box">
					<section>
						<form class="container">
							<b-form-row>
								<b-form-group class="col-lg-3 col-12" :label="$t('dashboard.startDate')">
									<b-form-datepicker :locale="$root.store.state.currentUser.lang" :class="{'active-filter':filters.startDate}" reset-button size="sm" v-model="filters.startDate"/>
								</b-form-group>

								<b-form-group class="col-lg-3 col-12" :label="$t('dashboard.endDate')">
									<b-form-datepicker :locale="$root.store.state.currentUser.lang" :class="{'active-filter':filters.endDate}" reset-button  size="sm" v-model="filters.endDate"/>
								</b-form-group>

								<b-form-group class="col-lg-3 col-10 table-responsive text-lg-center" :label="$t('dashboard.compareBy')">
									<b-form-radio-group
										class="btn_sc"
										v-model="filters.groupByCriteria"
										:options="optionsRadio"
										buttons
										button-variant="outline-info"
									></b-form-radio-group>
								</b-form-group>
								<b-form-group class="col-lg-1 col-2 table-responsive" label="">
									<br>
									<b-button variant="outline-primary" type="button" @click="checkform()"><md-icon icon="search"/></b-button>
								</b-form-group>
							</b-form-row>
						</form>
					</section>
					<br>


					<section class="container">
						<b-row>
							<b-col class="col-lg-3 col-12">
								<Cards :filters="filtersClean" :triggerSearch="triggerSearch"></Cards>
							</b-col>
							<b-col class="col-lg-9 col-12">
								<div class="alert alert-info text-center" role="alert">
									<b>{{$t("reports.referenceData")}}</b>
								</div>
								<b-row>
									<b-col class="col-lg-6 col-12">
										<ChartPerStatus
										:filters="filtersClean"
										:triggerSearch="triggerSearch"
										></ChartPerStatus>
									</b-col>
									<b-col class="col-lg-6 col-12  mt-lg-0 mt-3">
										<ChartRevenuePerStatus
										:filters="filtersClean"
										:triggerSearch="triggerSearch"
										></ChartRevenuePerStatus>
									</b-col>
								</b-row>
								<b-row>
									<b-col class="col-lg-6 col-12 mt-lg-3 mt-3">
										<ChartPerStatusPie
										:filters="filtersClean"
										:triggerSearch="triggerSearch"
										></ChartPerStatusPie>
									</b-col>
									<b-col class="col-lg-6 col-12  mt-lg-3 mt-3">
										<DriverPerfomance
										:filters="filtersClean"
										:triggerSearch="triggerSearch">
										</DriverPerfomance>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</section>


				</div>
			</div>
        </MainLayout>
    </section>
</template>
<script>
	import Cards from './Cards.vue'
	import DriverPerfomance from "./DriversPerformance.vue"
    import MainLayout from '../layout/MainLayout.vue'
	import ChartPerStatus from './charts/RidesPerStatus.vue'
	import ChartRevenuePerStatus from './charts/RevenuePerStatus.vue'
	import ChartPerStatusPie from './charts/RidesPerStatusPie.vue'
    import moment from 'moment'
	import helpers from '../reports/helpers/Reports.js'
    export default {
        name: "Index",
        components:{MainLayout,ChartPerStatus,ChartPerStatusPie,ChartRevenuePerStatus,Cards,DriverPerfomance},
		mixins:[helpers],
        data(){
            let pickUpStart = moment().subtract(7, 'days').format("YYYY-MM-DD");
            let pickUpEnd = moment().subtract(1, 'days').format("YYYY-MM-DD");
			const defaultOptionsRadio  = [
				{ text: this.$t("dashboard.day"), value: 'per-day',disabled:false },
				{ text: this.$t("dashboard.week"), value: 'per-week' ,disabled:false},
				{ text: this.$t("dashboard.month"), value: 'per-month',disabled:false},
				{ text: this.$t("dashboard.year"), value: 'per-year' ,disabled:false},
			];
            return {
                triggerSearch:0,
                filters:{
                    dateCriteria:'service-date',
                    startDate:pickUpStart,
                    endDate:pickUpEnd,
                    groupByCriteria:'per-day'
                },
                optionsRadio:[...defaultOptionsRadio],
				optionsRadioDefault:[...defaultOptionsRadio],
                optionsCriteriaDates:[
                    { text: 'Por fecha de servicio', value: 'service-date'},
                    { text: 'Por fecha de reserva', value: 'reservation-date' },
                ]
            }
        },
        methods:{
            checkform(){
                let errors = [];
                if(this.filters.startDate ==="" || this.filters.endDate === ""){
                    errors.push("Fecha inicio y fecha fin son requeridos");
                }
                if(this.filters.dateCriteria ===""){
                    errors.push("Criterio fechas es requerido");
                }
                if(errors.length===0){
                    this.search();
                }else{
                    this.$root.showAlert(errors[0],{variant:'warning'});
                }
            },
            search(){
				try{
					let startDate = moment(this.filters.startDate);
					let endDate   = moment(this.filters.endDate);
					this.dateRangeLimit(startDate,endDate)
					this.triggerSearch++;
				}catch(err){
					console.warn(err)
				}
            }
        },
        mounted(){
            this.checkform();//realiza la busqueda
        },
        computed:{
			filtersClean(){
				let cpFilters = {...this.filters};
				return cpFilters;
			},
			datesFiltersVariable(){
				return [this.filters.startDate,this.filters.endDate]
			}
		},
		watch:{
			filtersClean: function(){
				let result        = this.optionsRadio.find(({ value }) => value === "per-day");
				result.disabled   = false;
				let startDate = moment(this.filters.startDate);
				let endDate   = moment(this.filters.endDate);
				let days          = endDate.diff(startDate,"days")
				if(days>60){
					if(this.filters.groupByCriteria=="per-day"){
						this.filters.groupByCriteria='per-week';
					}
					let result = this.optionsRadio.find(({ value }) => value === "per-day");
					result.disabled = true;
				}
			}
		}
    }
</script>


